var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message != '')?_c('div',{staticClass:"message-area"},[_c('span',{staticClass:"box-title"},[_vm._v("講師からのメッセージ")]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.autoLink(_vm.message)))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }